'use client'

import { forwardRef, type AnchorHTMLAttributes } from 'react'
import { DISCORD_INVITE_URL } from '@/lib/constants'
import { trackDiscordLinkClicked, type DiscordLinkSource } from '@/lib/analytics'

interface TrackedDiscordLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'> {
  source: DiscordLinkSource
}

export const TrackedDiscordLink = forwardRef<HTMLAnchorElement, TrackedDiscordLinkProps>(function TrackedDiscordLink(
  { source, onClick, ...props },
  ref,
) {
  return (
    <a
      {...props}
      ref={ref}
      href={DISCORD_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => {
        trackDiscordLinkClicked({ source })
        onClick?.(event)
      }}
    />
  )
})
